<template>
  <div class="layout-mood-globe-content" id="identidade-visual-mood-gobo" data-search-anchor>
    <div class="descriptiom-layout-mood-globe-wrapper">
      <div class="icon-wrapper">
        <IconCheck />
        <p class="layout-mood-globe-description">{{ layoutMoodGlobeDescription1 }}</p>
      </div>
    </div>
    <div
      class="layout-mood-globe-card-item"
      :style="{ backgroundImage: `url(${layoutMoodGlobeImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import LayoutPageMixin from '@/mixins/layout-page-mixin'
import { LayoutPageStore } from '@/store/visual-identity-page/layout-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCheck } })
export default class LayoutsMoodGlobeSection extends Mixins(LayoutPageMixin) {
  layoutPageStore: PageStoreContract = getModule(LayoutPageStore, this.$store)

  get layoutMoodGlobeDescription1(): string {
    return this.getElementText(13, 0)
  }

  get layoutMoodGlobeImageSrc(): string {
    return this.getElementMedia(13, 1)
  }

  async getLayoutPage(): Promise<void> {
    await this.layoutPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.layoutPageStore.isLoading) {
      await this.getLayoutPage()
    }
  }
}
</script>

<style lang="scss">
.layout-mood-globe-content {
  display: grid;

  width: 100%;
  max-width: 1032px;
}

.descriptiom-layout-mood-globe-wrapper {
  padding: 2rem 0rem 0rem 0rem;
  position: relative;  

  display: grid;
  grid-template-columns: 50% 50%;
}

.layout-mood-globe-description {
  font-size: 25px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;

  padding-left: 7px;
  width: 374px;
}

.layout-mood-globe-card-item {
  position: relative;  

  max-width: 1032px;
  width: 100%;
  height: 705px;

  background-repeat: no-repeat;
  background-size: contain;
}
</style>
